import { z } from "zod";
import "../zod-runtime.js";
export const physicsVector3Schema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
});
export const physicsGrenadeTypeSchema = z.enum([
    "SMOKE",
    "MOLLY",
    "FLASH",
    "HE",
    "DECOY",
]);
export const physicsThrowModeSchema = z.enum(["overhand", "lob", "underhand"]);
export const physicsThrowStanceSchema = z.enum(["standing", "crouching"]);
export const physicsRulesetReferenceSchema = z.object({
    id: z.string().min(1),
    version: z.string().min(1),
});
export const mapPhysicsReferenceSchema = z.object({
    mapId: z.string().min(1),
    mapRevision: z.string().min(1),
    assetVersion: z.string().min(1),
});
export const throwIntentV2Schema = z.object({
    schemaVersion: z.literal(2),
    grenadeType: physicsGrenadeTypeSchema,
    origin: physicsVector3Schema,
    target: physicsVector3Schema,
    pitchDegrees: z.number().min(-90).max(90),
    yawDegrees: z.number().min(-180).max(180),
    strength: z.number().min(0).max(1),
    mode: physicsThrowModeSchema,
    stance: physicsThrowStanceSchema,
    playerVelocity: physicsVector3Schema,
});
export const trajectorySampleV2Schema = z.object({
    timeSeconds: z.number().min(0),
    position: physicsVector3Schema,
    velocity: physicsVector3Schema,
});
export const collisionEventV2Schema = z.object({
    timeSeconds: z.number().min(0),
    position: physicsVector3Schema,
    normal: physicsVector3Schema,
    surfaceId: z.string().min(1),
    materialId: z.string().min(1),
    incomingVelocity: physicsVector3Schema,
    outgoingVelocity: physicsVector3Schema,
});
export const trajectoryResultV2Schema = z.object({
    // v2: Zündung je Granatentyp (Zündzeit, Liegenbleiben, Aufprall).
    simulationVersion: z.union([z.literal(1), z.literal(2)]),
    ruleset: physicsRulesetReferenceSchema,
    mapAsset: mapPhysicsReferenceSchema.nullable(),
    samples: z.array(trajectorySampleV2Schema).min(1),
    collisions: z.array(collisionEventV2Schema),
    endReason: z.enum(["fuse", "stopped", "impact", "max_time"]),
    durationSeconds: z.number().min(0),
    finalPosition: physicsVector3Schema,
});
export const effectAreaV2Schema = z.object({
    layerId: z.string().min(1),
    boundary: z.array(physicsVector3Schema).min(3),
    intensity: z.number().min(0).max(1),
});
export const effectResultV2Schema = z.object({
    grenadeType: physicsGrenadeTypeSchema,
    ruleset: physicsRulesetReferenceSchema,
    mapAsset: mapPhysicsReferenceSchema,
    origin: physicsVector3Schema,
    startedAtSeconds: z.number().min(0),
    areas: z.array(effectAreaV2Schema),
    approximation: z.string().min(1).nullable(),
});
export const physicsReviewStateSchema = z.enum([
    "estimated_unreviewed",
    "reviewed",
]);
export const utilityPhysicsV2Schema = z.object({
    kind: z.literal("physics_v2"),
    reviewState: physicsReviewStateSchema,
    intent: throwIntentV2Schema,
    result: trajectoryResultV2Schema,
    landingErrorHu: z.number().min(0),
    effect: effectResultV2Schema.nullable(),
});
